import React, { useState, useEffect } from "react"
import { connect } from "react-redux"
import { Grid2QuestionnaireProgressWrapper } from "@thedgbrt/logology-ui-components"

const ProgressWrapper = ({ currentStep, children, saveStatus }) => {
  const [notification, setNotification] = useState(false)

  useEffect(() => {
    if (saveStatus === "success") {
      setNotification(true)
      const timer = setTimeout(() => {
        setNotification(false)
      }, 2000)
      return () => clearTimeout(timer)
    }
  }, [saveStatus])

  if (!currentStep || currentStep < 1) return children

  const getSteps = () => [
    {
      name: "my activity",
      active: currentStep >= 0,
    },
    {
      name: "brand personality",
      active: currentStep >= 3,
    },
    {
      name: "marketing voice",
      active: currentStep >= 11,
    },
    {
      name: "test results",
      active: currentStep >= 16,
    },
    {
      name: "tailored logos",
      active: false,
    },
  ]

  return (
    <Grid2QuestionnaireProgressWrapper
      steps={getSteps()}
      current={currentStep || 0}
      statusMessage={notification ? "progress saved" : ""}
      total={16}
    >
      {children}
    </Grid2QuestionnaireProgressWrapper>
  )
}

export default connect(({ questionnaire }) => {
  return { saveStatus: questionnaire.saveStatus }
})(ProgressWrapper)
